var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Widget',{attrs:{"title":"Flairs","area":this.$props.area,"scrollable":true}},[(_vm.hasData)?_vm._l((_vm.flairs),function(ref){
var name = ref.name;
var value = ref.value;
return _c('NameValue',{key:name,attrs:{"name":name,"value":value}})}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }